import { useFlag } from '@calendly/feature-check-react'

import { useProductRefreshBetaGate } from './useProductRefreshBetaGate'
import { useProductRefreshGlobalBetaEnabled } from './useProductRefreshGlobalBetaEnabled'

/**
 * Shared product-refresh gate for alpha + beta cohorts.
 *
 * - Alpha: the granular `ap_rebrand_*` flag (e.g. `APP_SHELL_FLAG_KEY`) — frozen cohort, no new enrollments.
 * - Beta: `ap_product_refresh_2026_global` when the beta gate passes (opt-in or forced rollout).
 *
 * Returns true when the beta gate is open AND (alpha flag is on OR user is in the global beta cohort).
 */
export function useProductRefreshExperienceEnabled(granularFlagKey: string): boolean {
  const betaGate = useProductRefreshBetaGate()
  const hasGlobalBeta = useProductRefreshGlobalBetaEnabled()
  const granularFlag = useFlag(granularFlagKey, false)

  return betaGate && (granularFlag || hasGlobalBeta)
}
